export default __webpack_public_path__ + "static/media/menina.20d3bf45.svg";